export const fullBookingStationTime = `
id
experience {
  id
}
station {
  id
}
tier {
  id
  length
  price
}
startedAt
endTime
amountDue
amountPaid
pausedAt
pausedDuration
discount {
  id
}
coupon {
  id
}
customerCard {
  id
  lastFour
}
createdAt
`;

export const fullBooking = `
id
title
startTime
deletedAt
updatedAt
checkedInAt
numPlayers
notifyHost
notes
host {
  id
  firstName
  lastName
  phone
  email
  birthday
  cards {
    id
    lastFour
  }
}
location {
  id
  waiversRequired
}
waiverNumSurprisedGuests
waiverNumMinors
waiverNumSigned
waiverReferenceHost
createdAt
imageUrl
bookingStationTimes {
  ${fullBookingStationTime}
}
transactions {
  id
  paymentStatusLink
}
`;
